import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import React from "react";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { routes } from "utilities/routing/generatedRoutes";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { useLoaderData } from "react-router";

const AdvancingTemplateList = () => {
  const viewModel = useLoaderData<server.viewmodel.AdvancingTemplateListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        perPage={50}
        filterSet="advancingTemplate_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        onNew={() => window.location.href = routes.advancingTemplate_New().absolute}
        title={viewModel.pageTitle}
        fetchFunction={window.CoreApi.AdvancingTemplate.Paginated}
        getId={a => a.advancingTemplateId}
        layout={{
          type: "table",
          columns: [{
            key: "advancingTemplateName",
            header: RESX.GeneralLabels.Name,
            render: item => <a href={routes.advancingTemplate_Detail(item.advancingTemplateId).absolute}>{item.name}</a>,
          }]
        }}
        filters={<Filters />}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>

    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

const Filters = () => {
  return <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
}

export default AdvancingTemplateList;